import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PlaybackAvailableType } from '../../contracts/playback-controller';

/**
 * Colour-coded vessel-type filter chips.
 *
 * No stylesheet of its own: it is projected into `app-toolbar-drawer`, which
 * owns the `.vtf*` vocabulary via ::ng-deep (component-scoped selectors do not
 * match projected content).
 */
@Component({
  selector: 'app-vessel-type-filter',
  templateUrl: './vessel-type-filter.component.html',
})
export class VesselTypeFilterComponent {
  @Input() availableTypes: PlaybackAvailableType[] = [];
  @Input() selected: Set<string> = new Set<string>();

  @Output() selectionChange = new EventEmitter<Set<string>>();

  isSelected(code: string): boolean {
    // Empty selection = all shown = every chip appears "on"
    return this.selected.size === 0 || this.selected.has(code);
  }

  toggle(code: string): void {
    const next = new Set(this.selected);
    if (next.size === 0) {
      // First interaction: switch from "all" to "only this one"
      next.add(code);
    } else if (next.has(code)) {
      next.delete(code);
    } else {
      next.add(code);
    }
    // All chips selected again → collapse back to "show all"
    if (next.size === this.availableTypes.length) next.clear();
    this.selectionChange.emit(next);
  }
}
